// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accessibility utilities */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Legacy toolbar styles (if still needed) */
.toolbar-row {
  background: var(--ion-color-primary);
  color: white;
}
.toolbar-row ion-button {
  --background: transparent;
}

.title-text {
  font-size: 18px;
  color: var(--ion-color-secondary);
}

/* Header section */
.header-block {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  /* Page title */
  /* Back button */
  /* Spacer for layout balance */
}
.header-block .page-title {
  font-size: 18px;
  color: var(--ion-color-secondary);
  margin: 0;
  font-family: AppFontBold, sans-serif;
  text-align: center;
  flex: 1;
}
.header-block .back-button {
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
}
.header-block .back-button:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.header-block .back-button:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.header-block .back-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.header-block .back-button:active {
  transform: scale(0.95);
}
.header-block .back-button ion-icon {
  width: 20px;
  height: 20px;
  color: var(--ion-color-secondary);
}
.header-block .spacer {
  min-width: 44px;
  min-height: 44px;
}

/* Header styling */
ion-header {
  --box-shadow: none !important;
  box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.0784313725) !important;
}

/* Main container */
.container {
  width: 100%;
}
@media (min-width: 991px) {
  .container {
    max-width: 50%;
    margin: 0 auto;
  }
}

/* Empty state */
.empty-state {
  padding: 40px 20px;
}
.empty-state .empty-message {
  font-size: 16px;
  color: var(--ion-color-medium);
  line-height: 1.5;
  margin: 0;
}

/* Orders section */
.orders-section {
  position: relative;
}

/* Swiper/Carousel styling */
swiper-container {
  --swiper-pagination-bottom: -3px !important;
  --swiper-pagination-color: var(--ion-color-secondary);
  --swiper-pagination-bullet-inactive-color: #cccccc;
  --swiper-pagination-bullet-size: 8px;
  --swiper-pagination-bullet-horizontal-gap: 4px;
  /* Focus styles for carousel navigation */
  /* Slide styling */
}
swiper-container:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
swiper-container swiper-slide {
  width: 100%;
  max-width: 100% !important;
  margin: 0px 0px 20px;
  padding: 20px;
  /* Focus styles for individual slides */
}
swiper-container swiper-slide:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}

/* Footer section */
ion-footer {
  padding: 0;
  box-shadow: 0px -4px 15px rgba(0, 0, 0, 0.1);
  background: white;
}
ion-footer .footer-content {
  padding: 15px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 991px) {
  ion-footer .footer-content {
    padding: 20px 50px;
  }
}

/* Reorder button */
.reorder-button {
  width: 100%;
  max-width: 400px;
  padding: 16px 24px;
  background: var(--ion-color-primary);
  color: white;
  border: none;
  border-radius: 8px;
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
  /* Disabled state */
}
.reorder-button:focus {
  outline: 2px solid var(--ion-color-primary-shade);
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(113, 167, 97, 0.25);
}
.reorder-button:focus-visible {
  outline: 2px solid var(--ion-color-primary-shade);
  outline-offset: 2px;
}
.reorder-button:hover:not(:disabled) {
  background-color: var(--ion-color-primary-shade);
  transform: translateY(-1px);
}
.reorder-button:active:not(:disabled) {
  background-color: var(--ion-color-primary-tint);
  transform: translateY(0);
}
.reorder-button:disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
  opacity: 0.7;
}
.reorder-button:disabled:hover {
  transform: none;
}
@media (min-width: 991px) {
  .reorder-button {
    width: 50%;
    max-width: 300px;
  }
}

/* Loading container */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.loading-container ion-spinner {
  --color: var(--ion-color-primary);
  width: 32px;
  height: 32px;
}

/* High contrast mode enhancements */
.bsg-high-contrast .header-block {
  border-bottom: 2px solid black;
}
.bsg-high-contrast .header-block .page-title {
  color: black !important;
}
.bsg-high-contrast .header-block .back-button:focus {
  outline: 3px solid #0078d7;
  background-color: #e6f3ff;
}
.bsg-high-contrast .header-block .back-button ion-icon {
  color: black !important;
}
.bsg-high-contrast .empty-message {
  color: black !important;
  background: white;
  border: 1px solid black;
  padding: 15px;
}
.bsg-high-contrast swiper-container {
  --swiper-pagination-color: black;
}
.bsg-high-contrast swiper-container:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast swiper-container swiper-slide:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast ion-footer {
  border-top: 2px solid black;
}
.bsg-high-contrast ion-footer .reorder-button {
  background: black !important;
  border: 2px solid white;
}
.bsg-high-contrast ion-footer .reorder-button:focus {
  box-shadow: 0 0 0 3px #0078d7;
}
.bsg-high-contrast ion-footer .reorder-button:disabled {
  background: #666666 !important;
  border: 1px dashed black;
}
.bsg-high-contrast .loading-container ion-spinner {
  --color: black;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .header-block {
    padding: 15px;
  }
  .header-block .page-title {
    font-size: 16px;
  }
  .header-block .back-button {
    min-width: 40px;
    min-height: 40px;
  }
  .header-block .back-button ion-icon {
    width: 18px;
    height: 18px;
  }
  .reorder-button {
    font-size: 14px;
    padding: 14px 20px;
  }
  swiper-container swiper-slide {
    padding: 15px;
  }
}
/* Animation for smooth interactions */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.orders-section {
  animation: fadeIn 0.3s ease-in-out;
}

/* Focus management for carousel */
swiper-container {
  /* Ensure carousel can receive focus for keyboard navigation */
}
swiper-container[tabindex="0"]:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/my-orders/my-orders.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA,4BAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AADF;;AAIA,4CAAA;AACA;EAIE,oCAAA;EACA,YAAA;AAJF;AAAE;EACE,yBAAA;AAEJ;;AAIA;EACE,eAAA;EACA,iCAAA;AADF;;AAIA,mBAAA;AACA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EAEA,eAAA;EAUA,gBAAA;EA0CA,8BAAA;AApDF;AACE;EACE,eAAA;EACA,iCAAA;EACA,SAAA;EACA,oCAAA;EACA,kBAAA;EACA,OAAA;AACJ;AAGE;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EAEA,iBAAA;EAMA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;AAhBJ;AAAI;EACE,2CAAA;EACA,mBAAA;AAEN;AAEI;EACE,2CAAA;EACA,mBAAA;AAAN;AAII;EACE,qCAAA;AAFN;AAMI;EACE,sBAAA;AAJN;AAOI;EACE,WAAA;EACA,YAAA;EACA,iCAAA;AALN;AAUE;EACE,eAAA;EACA,gBAAA;AARJ;;AAYA,mBAAA;AACA;EACE,6BAAA;EACA,mEAAA;AATF;;AAYA,mBAAA;AACA;EACE,WAAA;AATF;AC9FE;EDsGF;IAII,cAAA;IACA,cAAA;EARF;AACF;;AAWA,gBAAA;AACA;EACE,kBAAA;AARF;AAUE;EACE,eAAA;EACA,8BAAA;EACA,gBAAA;EACA,SAAA;AARJ;;AAYA,mBAAA;AACA;EACE,kBAAA;AATF;;AAYA,4BAAA;AACA;EACE,2CAAA;EACA,qDAAA;EACA,kDAAA;EACA,oCAAA;EACA,8CAAA;EAEA,yCAAA;EAMA,kBAAA;AAfF;AAUE;EACE,2CAAA;EACA,mBAAA;AARJ;AAYE;EACE,WAAA;EACA,0BAAA;EACA,oBAAA;EACA,aAAA;EAEA,uCAAA;AAXJ;AAYI;EACE,2CAAA;EACA,mBAAA;AAVN;;AAeA,mBAAA;AACA;EACE,UAAA;EACA,4CAAA;EACA,iBAAA;AAZF;AAcE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAZJ;AC3JE;EDmKA;IAOI,kBAAA;EAXJ;AACF;;AAeA,mBAAA;AACA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,2DAAA;EAEA,iBAAA;EAOA,0BAAA;EAMA,gBAAA;EAMA,iBAAA;EAMA,mBAAA;AAlCF;AAUE;EACE,iDAAA;EACA,mBAAA;EACA,8CAAA;AARJ;AAYE;EACE,iDAAA;EACA,mBAAA;AAVJ;AAcE;EACE,gDAAA;EACA,2BAAA;AAZJ;AAgBE;EACE,+CAAA;EACA,wBAAA;AAdJ;AAkBE;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AAhBJ;AAkBI;EACE,eAAA;AAhBN;AChNE;EDgLF;IAqDI,UAAA;IACA,gBAAA;EAjBF;AACF;;AAoBA,sBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAjBF;AAmBE;EACE,iCAAA;EACA,WAAA;EACA,YAAA;AAjBJ;;AAqBA,oCAAA;AAEE;EACE,8BAAA;AAnBJ;AAqBI;EACE,uBAAA;AAnBN;AAuBM;EACE,0BAAA;EACA,yBAAA;AArBR;AAwBM;EACE,uBAAA;AAtBR;AA2BE;EACE,uBAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;AAzBJ;AA4BE;EACE,gCAAA;AA1BJ;AA4BI;EACE,0BAAA;AA1BN;AA6BI;EACE,0BAAA;AA3BN;AA+BE;EACE,2BAAA;AA7BJ;AA+BI;EACE,4BAAA;EACA,uBAAA;AA7BN;AA+BM;EACE,6BAAA;AA7BR;AAgCM;EACE,8BAAA;EACA,wBAAA;AA9BR;AAmCE;EACE,cAAA;AAjCJ;;AAqCA,2BAAA;AACA;EACE;IACE,aAAA;EAlCF;EAoCE;IACE,eAAA;EAlCJ;EAqCE;IACE,eAAA;IACA,gBAAA;EAnCJ;EAqCI;IACE,WAAA;IACA,YAAA;EAnCN;EAwCA;IACE,eAAA;IACA,kBAAA;EAtCF;EAyCA;IACE,aAAA;EAvCF;AACF;AA0CA,sCAAA;AACA;EACE;IACE,UAAA;IACA,2BAAA;EAxCF;EA0CA;IACE,UAAA;IACA,wBAAA;EAxCF;AACF;AA2CA;EACE,kCAAA;AAzCF;;AA4CA,kCAAA;AACA;EACE,8DAAA;AAzCF;AA2CI;EACE,2CAAA;EACA,mBAAA;AAzCN","sourcesContent":["@import '../../../theme/mixins';\n\n/* Accessibility utilities */\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Legacy toolbar styles (if still needed) */\n.toolbar-row {\n  ion-button {\n    --background: transparent;\n  }\n  background: var(--ion-color-primary);\n  color: white;\n}\n\n.title-text {\n  font-size: 18px;\n  color: var(--ion-color-secondary);\n}\n\n/* Header section */\n.header-block {\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: white;\n  \n  /* Page title */\n  .page-title {\n    font-size: 18px;\n    color: var(--ion-color-secondary);\n    margin: 0;\n    font-family: AppFontBold, sans-serif;\n    text-align: center;\n    flex: 1;\n  }\n  \n  /* Back button */\n  .back-button {\n    background: transparent;\n    border: none;\n    padding: 8px;\n    cursor: pointer;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 44px;\n    min-height: 44px;\n    \n    /* Focus styles */\n    &:focus {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Keyboard focus styles */\n    &:focus-visible {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Hover state */\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n    \n    /* Active state */\n    &:active {\n      transform: scale(0.95);\n    }\n    \n    ion-icon {\n      width: 20px;\n      height: 20px;\n      color: var(--ion-color-secondary);\n    }\n  }\n  \n  /* Spacer for layout balance */\n  .spacer {\n    min-width: 44px;\n    min-height: 44px;\n  }\n}\n\n/* Header styling */\nion-header {\n  --box-shadow: none !important;\n  box-shadow: 0px 4px 45px 0px #00000014 !important;\n}\n\n/* Main container */\n.container {\n  width: 100%;\n  \n  @include desktop {\n    max-width: 50%;\n    margin: 0 auto;\n  }\n}\n\n/* Empty state */\n.empty-state {\n  padding: 40px 20px;\n  \n  .empty-message {\n    font-size: 16px;\n    color: var(--ion-color-medium);\n    line-height: 1.5;\n    margin: 0;\n  }\n}\n\n/* Orders section */\n.orders-section {\n  position: relative;\n}\n\n/* Swiper/Carousel styling */\nswiper-container {\n  --swiper-pagination-bottom: -3px !important;\n  --swiper-pagination-color: var(--ion-color-secondary);\n  --swiper-pagination-bullet-inactive-color: #cccccc;\n  --swiper-pagination-bullet-size: 8px;\n  --swiper-pagination-bullet-horizontal-gap: 4px;\n  \n  /* Focus styles for carousel navigation */\n  &:focus {\n    outline: 2px solid var(--ion-color-primary);\n    outline-offset: 2px;\n  }\n  \n  /* Slide styling */\n  swiper-slide {\n    width: 100%;\n    max-width: 100% !important;\n    margin: 0px 0px 20px;\n    padding: 20px;\n    \n    /* Focus styles for individual slides */\n    &:focus {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n  }\n}\n\n/* Footer section */\nion-footer {\n  padding: 0;\n  box-shadow: 0px -4px 15px rgba(0, 0, 0, 0.1);\n  background: white;\n  \n  .footer-content {\n    padding: 15px 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    \n    @include desktop {\n      padding: 20px 50px;\n    }\n  }\n}\n\n/* Reorder button */\n.reorder-button {\n  width: 100%;\n  max-width: 400px;\n  padding: 16px 24px;\n  background: var(--ion-color-primary);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-family: AppFontBold, sans-serif;\n  font-size: 16px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n  \n  /* Focus styles */\n  &:focus {\n    outline: 2px solid var(--ion-color-primary-shade);\n    outline-offset: 2px;\n    box-shadow: 0 0 0 4px rgba(113, 167, 97, 0.25);\n  }\n  \n  /* Keyboard focus styles */\n  &:focus-visible {\n    outline: 2px solid var(--ion-color-primary-shade);\n    outline-offset: 2px;\n  }\n  \n  /* Hover state */\n  &:hover:not(:disabled) {\n    background-color: var(--ion-color-primary-shade);\n    transform: translateY(-1px);\n  }\n  \n  /* Active state */\n  &:active:not(:disabled) {\n    background-color: var(--ion-color-primary-tint);\n    transform: translateY(0);\n  }\n  \n  /* Disabled state */\n  &:disabled {\n    background-color: #cccccc;\n    color: #666666;\n    cursor: not-allowed;\n    opacity: 0.7;\n    \n    &:hover {\n      transform: none;\n    }\n  }\n  \n  @include desktop {\n    width: 50%;\n    max-width: 300px;\n  }\n}\n\n/* Loading container */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  \n  ion-spinner {\n    --color: var(--ion-color-primary);\n    width: 32px;\n    height: 32px;\n  }\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n  .header-block {\n    border-bottom: 2px solid black;\n    \n    .page-title {\n      color: black !important;\n    }\n    \n    .back-button {\n      &:focus {\n        outline: 3px solid #0078d7;\n        background-color: #e6f3ff;\n      }\n      \n      ion-icon {\n        color: black !important;\n      }\n    }\n  }\n  \n  .empty-message {\n    color: black !important;\n    background: white;\n    border: 1px solid black;\n    padding: 15px;\n  }\n  \n  swiper-container {\n    --swiper-pagination-color: black;\n    \n    &:focus {\n      outline: 3px solid #0078d7;\n    }\n    \n    swiper-slide:focus {\n      outline: 3px solid #0078d7;\n    }\n  }\n  \n  ion-footer {\n    border-top: 2px solid black;\n    \n    .reorder-button {\n      background: black !important;\n      border: 2px solid white;\n      \n      &:focus {\n        box-shadow: 0 0 0 3px #0078d7;\n      }\n      \n      &:disabled {\n        background: #666666 !important;\n        border: 1px dashed black;\n      }\n    }\n  }\n  \n  .loading-container ion-spinner {\n    --color: black;\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .header-block {\n    padding: 15px;\n    \n    .page-title {\n      font-size: 16px;\n    }\n    \n    .back-button {\n      min-width: 40px;\n      min-height: 40px;\n      \n      ion-icon {\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n  \n  .reorder-button {\n    font-size: 14px;\n    padding: 14px 20px;\n  }\n  \n  swiper-container swiper-slide {\n    padding: 15px;\n  }\n}\n\n/* Animation for smooth interactions */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.orders-section {\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n/* Focus management for carousel */\nswiper-container {\n  /* Ensure carousel can receive focus for keyboard navigation */\n  &[tabindex=\"0\"] {\n    &:focus {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n  }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
